import { categoryService } from "@features/categorydocument/CategoryDocumentService";
import { CategoryDocumentOutputDTO } from '@features/categorydocument/types';
import createEntitySlice from "@services/createEntitySlice";

const {
  reducer: CategoryDocumentReducer,
  actions: CategoryDocumentActions,
  fetchAll: fetchCategoryDocuments,
  fetchById: fetchCategoryDocumentById,
  createEntity: createCategoryDocument,
  updateEntity: updateCategoryDocument,
  deleteEntity: deleteCategoryDocument,
} = createEntitySlice<CategoryDocumentOutputDTO>("CategoryDocument", categoryService);

export {
  CategoryDocumentReducer,
  CategoryDocumentActions,
  fetchCategoryDocuments,
  fetchCategoryDocumentById,
  createCategoryDocument,
  updateCategoryDocument,
  deleteCategoryDocument,
}; 